import { Rule } from './rule';

export class SlotsCheatSheet {
  public static readonly allCheatSheets: Rule[] = [
    {
      title: 'components.cheat-sheet.slots.header-1',
      body: [
        {
          type: 'text',
          content: 'components.cheat-sheet.slots.body-1',
        },
      ],
    },
    {
      title: 'components.cheat-sheet.slots.header-2',
      body: [
        { type: 'text', content: 'components.cheat-sheet.slots.body-2a' },
        { type: 'text', content: 'components.cheat-sheet.slots.body-2b' },
        { type: 'text', content: 'components.cheat-sheet.slots.body-2c' },
      ],
    },
    {
      title: 'components.cheat-sheet.slots.header-3',
      body: [
        { type: 'text', content: 'components.cheat-sheet.slots.body-3a' },
        { type: 'text', content: 'components.cheat-sheet.slots.body-3b' },
      ],
    },
    {
      title: 'components.cheat-sheet.slots.header-4',
      body: [
        { type: 'text', content: 'components.cheat-sheet.slots.body-4a' },
        { type: 'text', content: 'components.cheat-sheet.slots.body-4b' },
        { type: 'text', content: 'components.cheat-sheet.slots.body-4c' },
      ],
    },
    {
      title: 'components.cheat-sheet.slots.header-5',
      body: [
        { type: 'text', content: 'components.cheat-sheet.slots.body-5a' },
        { type: 'text', content: 'components.cheat-sheet.slots.body-5b' },
      ],
    },
    {
      title: 'components.cheat-sheet.slots.header-6',
      body: [
        { type: 'text', content: 'components.cheat-sheet.slots.body-6a' },
        { type: 'text', content: 'components.cheat-sheet.slots.body-6b' },
        { type: 'text', content: 'components.cheat-sheet.slots.body-6c' },
        { type: 'text', content: 'components.cheat-sheet.slots.body-6d' },
      ],
    },
  ];
}
